import { render, staticRenderFns } from "./depotIcon.vue?vue&type=template&id=cbca9642&"
import script from "./depotIcon.vue?vue&type=script&lang=js&"
export * from "./depotIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports